import React from 'react';
import { Form } from 'antd';
import CardRadioGroup from '../../components/CardRadioGroup';
import s from '../../s.module.less';
import sc from './s.module.less';

const AlertIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="m21.73 18-8-14a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" fill="currentColor" />
        <path d="M12 10v3.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="16.8" r="1.1" fill="#fff" />
    </svg>
);

// Step 7 — Clearinghouse connection：switch / keep 单选（默认 switch，实际可选）
export default function StepClearinghouse() {
    return (
        <>
            <div className={sc.amber}>
                <AlertIcon />
                <div className={sc.amberBody}>
                    Routing remittances through our clearinghouse improves visibility into{' '}
                    <strong>insurance reimbursement</strong> and helps us <strong>track actual disbursement</strong>{' '}
                    (what hit your bank versus what payers adjudicated). When those do not line up, we can troubleshoot
                    faster with fuller context.
                </div>
            </div>
            <div className={s.wizSection} data-wiz-section>
                <Form.Item name={['clearinghouse', 'choice']} initialValue="switch" noStyle>
                    <CardRadioGroup
                        options={[
                            {
                                value: 'switch',
                                title: "Yes, switch to Klarity's clearinghouse",
                                recommended: true,
                                recommendedLabel: 'Strongly recommended',
                                desc: 'Payers still pay you directly, into the same account. The only change is that your payment reports come from Klarity instead of your old clearinghouse, so we can track every claim for you.',
                            },
                            {
                                value: 'keep',
                                title: 'No, keep my current clearinghouse',
                                desc: 'Your existing setup stays the same, and your payment reports keep going to your current clearinghouse instead of Klarity.',
                                note: 'Most providers do not choose this. Some payers give us no other way to check claim status, so we may not be able to track your claims. If you keep your clearinghouse, you cannot submit until our billing team has met with you.',
                            },
                        ]}
                    />
                </Form.Item>
            </div>
        </>
    );
}
